 <template>
  <div>
    <v-toolbar
      :style="$vuetify.breakpoint.smAndDown ? ' margin-left: 0; width: 100%;' : 'margin-left: 61px; width: 95.5%;'"
      style="position: fixed; z-index: 999"
      class="primary1"
      height="60"
      v-model="show"
      :bottom="true"
      elevation="3"
    >
      <v-container fluid pa-0 ma-0>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="auto">
            <v-list shaped nav color="primary1" class="pa-0">
              <v-list-item-group style="display: inline-flex" v-model="opcao">
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  @click="menuCadu(index)"
                  target="_blank"
                  style="margin: 0 !important; color: white !important"
                  :style="
                    opcao == index && index == 1
                      ? 'background-color: white !important;'
                      : 'background-color: #00995d !important'
                  "
                  :ripple="false"
                  :href="item.href"
                  link
                >
                  <v-list-item-icon style="margin: 8.5px -0.5px 8.5px 8.5px">
                    <v-icon
                      style="margin-top: 3px; width: 30px; min-width: 30px; height: 30px"
                      :style="opcao == index && index == 1 ? 'color: #00995d !important' : 'white'"
                      class="white--text"
                      >{{ item.icon }}</v-icon
                    >
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-navigation-drawer
              v-model="menu"
              absolute
              bottom
              temporary
              hide-overlay
              :style="
                menu
                  ? { bottom: '60px', 'min-height': height - 120 + 'px' }
                  : { bottom: '0px', 'min-height': height - 120 + 'px' }
              "
            >
              <v-list nav dense class="ml-3" elevation="0">
                <v-subheader class="font-primaria headline font-weight-bold primary1--text">Sistema Cadu</v-subheader>
                <v-list-group
                  v-model="active"
                  :prepend-icon="abasCadu[0].icon"
                  color="black"
                  class="menu-bottom"
                  no-action
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title class="body-1" v-text="abasCadu[0].msg"></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item v-for="(subItem, index) in itemsUnimedFiltro" :key="index" class="list-item-left" link>
                    <v-list-item-content @click="entrarUnimed(index)">
                      <v-list-item-title class="body-1" v-html="subItem"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
                <v-list-item>
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <div
                        @click="roterPath(aba)"
                        style="cursor: pointer"
                        class="body-1"
                        :class="index > 0 ? 'mt-1' : ''"
                        v-for="(aba, index) in abasFiltradas"
                        :key="index"
                      >
                        <v-icon style="width: 30px; height: 30px" class="mt-1" color="primary1">
                          {{ aba.icon }}
                        </v-icon>
                        {{ aba.msg }}
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
    <overlay-loading v-model="loadingOverlay" />
    <SucessoModal :genericMessage="'Manual baixado com sucesso.'" :showSucess="showSucess" @close="closeSucessModal" />
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import Redirect from '@/services/Redirect'
import Manual from '@/services/Manual/Manual'
import { EventBus } from './../../../services/EventBus/EventBus'

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      menu: false,
      opcao: -1,
      group: null,
      height: 0,
      role: '',
      active: false,
      itemsUnimed: ['Visualizar', 'Editar'],
      abasCadu: [
        {
          icon: '$vuetify.icon.userNormal',
          msg: 'Minha Unimed',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        {
          icon: '$vuetify.icon.monitorNormal',
          msg: 'Consultar Unimeds',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        { icon: '$vuetify.icon.usersNormal', msg: 'Cooperados', roles: [] },
        {
          icon: '$vuetify.icon.layersNormal',
          msg: 'Dirigentes',
          roles: ['admin_brasil', 'dirigente', 'colaborador_dirigente']
        },
        {
          icon: '$vuetify.icon.clipboardNormal',
          msg: 'Relatórios',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        {
          icon: '$vuetify.icon.settingsNormal',
          msg: 'Administração',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        { icon: '$vuetify.icon.refreshccwNormal', msg: 'Transações Online', roles: ['admin_brasil'] },
        { icon: '$vuetify.icon.inboxNormal', msg: 'Pendências', roles: ['admin_brasil'] },
        {
          icon: '$vuetify.icon.heartNormal',
          msg: 'Cadbenef',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        }
      ],
      items: [
        { title: 'Dashboard', icon: '$vuetify.icon.home' },
        { title: 'Account', icon: '$vuetify.icon.menu' },
        { title: 'tt', icon: '$vuetify.icon.book' }
      ],
      errObj: {
        status: '',
        error: ''
      },
      tokenBearer: '',
      loadingOverlay: false,
      showSuccess: false,
      error: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)

    this.acessoCadBenef = decoded.acessoCadBenef
    if (!this.acessoCadBenef) {
      this.abasCadu.pop()
    }
    this.items[2].href = this.$appConfig.config.MANUAL
    this.role = decoded.role
  },
  computed: {
    abasFiltradas() {
      return this.abasCadu.filter((el, index) => {
        if (index > 0) {
          return el.roles.includes(this.role)
        }
      })
    },
    canEdit() {
      return ['admin_brasil', 'admin', 'dirigente'].includes(this.role)
    },
    itemsUnimedFiltro() {
      return this.itemsUnimed.filter((el, index) => {
        if (index === 0) {
          return el
        } else if (this.canEdit) {
          return el
        }
      })
    }
  },
  beforeDestroy() {
    EventBus.$off('visualizarUnimed')
    EventBus.$off('editarUnimed')
  },
  methods: {
    entrarUnimed(index) {
      this.active = false
      if (index === 0) {
        EventBus.$emit('visualizarUnimed')
      } else {
        this.menu = false
        EventBus.$emit('editarUnimed')
      }
    },
    roterPath(aba) {
      const msg = aba.msg.toLowerCase()

      switch (msg) {
        case 'minha unimed':
          this.goToMinhaUnimed()
          break
        case 'consultar unimeds':
          this.$router.push('/consultarUnimed')
          break
        case 'dirigentes':
          this.$router.push('/dirigentes')
          break
        case 'administração':
          this.$router.push('/administracao')
          break
        case 'cadbenef':
          this.redirectLink()
          break
        case 'pendências':
          this.$router.push('/pendencias')
          break
        case 'transações online':
          this.$router.push('/transacaoOnline')
          break
        case 'relatórios':
          this.$router.push('/relatorios')
          break
      }
    },
    goToMinhaUnimed() {
      EventBus.$emit('breadCrumbPast', 0)
      localStorage.setItem('optionEdit', false)
      this.$router.push({ path: '/minhaUnimed' })
      this.menu = false
    },
    async menuCadu(index) {
      switch (index) {
        case 0:
          if (this.$router.history.current.name !== 'home') this.$router.push('/home')
          break
        case 1:
          this.opcao = 1
          this.menu = true
          break
        case 2:
          await this.downloadFile();
          break
        default:
          this.opcao = index
          this.menu = false
          break
      }
    },
    async downloadFile() {
      this.loadingOverlay = true
          let arquivo = `${this.$appConfig.config.API}/api/arquivos/manual/`
          let manual = new Manual(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
          try {
            let uuidArquivo = await manual.getUuid()
            arquivo += uuidArquivo.data

            let response = await manual.exportar(arquivo)
            let content = response.headers['content-disposition']
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
            document.body.appendChild(link)
            link.click()
            this.loadingOverlay = false
            this.showSuccess = true
          } catch (err) {
            this.error = true
            console.error(err)
            this.showError = true
            this.errObj.status = err.responseManual.status
            this.errObj.error = err.responseManual.message
          }
    },
    async redirectLink() {
      let redirect = new Redirect(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      try {
        let response = await redirect.getCadBenef()
        let url = response.data

        window.open(url, '_blank')
      } catch (err) {
        console.error(err)
      }
    }
  },
  watch: {
    menu() {
      if (!this.menu && this.opcao === 1) {
        this.opcao = -1
        this.active = false
      }
    }
  },
  updated() {
    this.height = window.innerHeight
  }
}
</script>

<style lang="sass">
.mt--1
  margin-top: 6px

.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), .v-navigation-drawer--temporary:not(.v-navigation-drawer--close)
  -webkit-box-shadow: none
  box-shadow: none

.v-list-item--link::before
  transition: none

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled)
  color: none !important

.v-list-item--link:before
  background-color: transparent !important

.v-application--is-ltr .v-list--shaped .v-list-item, .v-application--is-ltr .v-list--shaped .v-list-item::before, .v-application--is-ltr .v-list--shaped .v-ripple__container
  border-bottom-right-radius: 0 !important
  border-top-right-radius: 32px !important
  border-top-left-radius: 32px !important

.menu-bottom
  min-height: 32px
  .v-list-group__header
    min-height: 10px
    height: 28px
    .v-list-item__icon
      margin-top: 2px
      color: #00995d
</style>
